import { useState, useRef, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Assistant from './Assistant';
import Agents from './Agents';
import AgentEdit from './agent-edit';
import AgentData from './agent-data';
import AgentTables from './agent-tables';
import Datasources from './Datasources';
import DatasourceEdit from './datasource-edit';
import Modelconnectors from './Modelconnectors';
import ModelconnectorEdit from './Modelconnector-edit';
import { getUserProfile } from '../utils/auth';

function Home() {
  const [leftWidth, setLeftWidth] = useState(() => {
    const saved = localStorage.getItem('leftPanelWidth');
    return saved ? parseFloat(saved) : 70;
  });
  const isDragging = useRef(false);
  const [showUserPopover, setShowUserPopover] = useState(false);
  const [activePage, setActivePage] = useState('Dashboard');
  const [editingDatasource, setEditingDatasource] = useState(null);
  const [editingAgent, setEditingAgent] = useState(null);
  const [editingModelconnector, setEditingModelconnector] = useState(null);
  const [viewingAgentUsage, setViewingAgentUsage] = useState(null);
  const [viewingAgentTables, setViewingAgentTables] = useState(null);
  const [isRightPanelCollapsed, setIsRightPanelCollapsed] = useState(() => {
    const saved = localStorage.getItem('isRightPanelCollapsed');
    return saved ? JSON.parse(saved) : false;
  });
  const [showUnsavedModal, setShowUnsavedModal] = useState(false);
  const [pendingNavigation, setPendingNavigation] = useState(null);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [hasUnsavedDatasourceChanges, setHasUnsavedDatasourceChanges] = useState(false);
  const [hasUnsavedModelconnectorChanges, setHasUnsavedModelconnectorChanges] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const page = searchParams.get('page');
    const dsId = searchParams.get('dsId');
    const agentId = searchParams.get('agentId');
    const editAgent = searchParams.get('editAgent');
    if (page === 'datasources') {
      setActivePage('Data Sources');
    }
    if (page === 'agents') {
      setActivePage('Agents');
    }
    if (page === 'agent-usage') {
      setActivePage('Agents');
      setViewingAgentUsage({ id: agentId });
    }
    if (editAgent) {
      console.log('Setting editingAgent to:', editAgent);
      setEditingAgent(editAgent);
      setActivePage('Agents');
      setHasUnsavedChanges(false);
    }
    if (dsId) {
      setEditingDatasource(dsId);
      setActivePage('Data Sources');
      setHasUnsavedDatasourceChanges(false);
    }
  }, [searchParams]);

  const handleLogout = () => {
    // document.cookie = 'access-token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    // document.cookie = 'access-token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=' + process.env.REACT_APP_UI_DOMAIN + ";";
    // localStorage.removeItem('chatThread');
    // localStorage.removeItem('messagesFetched');
    navigate('/logout');
  };

  const handleMouseDown = () => {
    isDragging.current = true;
  };

  const handleMouseMove = (e) => {
    if (!isDragging.current || isRightPanelCollapsed) return;
    const containerWidth = e.currentTarget.offsetWidth;
    const newLeftWidth = (e.clientX / containerWidth) * 100;
    const newWidth = Math.max(30, Math.min(90, newLeftWidth));
    setLeftWidth(newWidth);
    localStorage.setItem('leftPanelWidth', newWidth.toString());
  };

  const toggleRightPanel = () => {
    const newCollapsed = !isRightPanelCollapsed;
    setIsRightPanelCollapsed(newCollapsed);
    localStorage.setItem('isRightPanelCollapsed', JSON.stringify(newCollapsed));
  };

  const handleSidebarClick = (page) => {
    console.log('Sidebar clicked:', page, 'editingAgent:', editingAgent, 'hasUnsavedChanges:', hasUnsavedChanges);
    if ((editingAgent && hasUnsavedChanges) || (editingDatasource && hasUnsavedDatasourceChanges) || (editingModelconnector && hasUnsavedModelconnectorChanges)) {
      console.log('Setting modal to show');
      setPendingNavigation(page);
      setShowUnsavedModal(true);
    } else {
      if (page === 'Agents' && editingAgent) {
        setEditingAgent(null);
      }
      if (page === 'Data Sources' && editingDatasource) {
        setEditingDatasource(null);
      }
      if (page === 'Model Connectors' && editingModelconnector) {
        setEditingModelconnector(null);
      }
      setActivePage(page);
    }
  };

  const confirmNavigation = () => {
    if (pendingNavigation === 'Agents') {
      setEditingAgent(null);
    }
    if (pendingNavigation === 'Data Sources') {
      setEditingDatasource(null);
    }
    if (pendingNavigation === 'Model Connectors') {
      setEditingModelconnector(null);
    }
    setActivePage(pendingNavigation);
    setShowUnsavedModal(false);
    setPendingNavigation(null);
    setHasUnsavedChanges(false);
    setHasUnsavedDatasourceChanges(false);
    setHasUnsavedModelconnectorChanges(false);
  };

  const cancelNavigation = () => {
    setShowUnsavedModal(false);
    setPendingNavigation(null);
  };

  const handleMouseUp = () => {
    isDragging.current = false;
  };



  return (
    <div className="app">
      <div className="header">
        <img src="./media/applucent-logo.jpeg" alt="Logo" className="logo" />
        <div className="icons">
          <img src="./media/alerts.png" alt="Alerts" className="icon" />
          <img src="./media/help.png" alt="Help" className="icon" />
          <img src="./media/settings.png" alt="Settings" className="icon" />
          <div 
            className="user-icon-container"
            onMouseEnter={() => setShowUserPopover(true)}
            onMouseLeave={() => setShowUserPopover(false)}
          >
            <img 
              src="./media/user.png" 
              alt="User" 
              className="icon" 
            />
            {showUserPopover && (
              <div className="user-popover">
                {(() => {
                  const profile = getUserProfile();
                  return profile ? (
                    <div>
                      <div><strong>{profile.first_name} {profile.last_name}</strong></div>
                      <div>{profile.email}</div>
                      <hr style={{margin: '10px 0'}} />
                      <div 
                        onClick={handleLogout} 
                        style={{cursor: 'pointer', color: '#007bff'}}
                      >
                        Logout
                      </div>
                    </div>
                  ) : (
                    <div>Not logged in</div>
                  );
                })()}
              </div>
            )}
          </div>
        </div>
      </div>
      <div 
        className="main-content"
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        >
        <div className="left-panel" style={{ width: isRightPanelCollapsed ? '100%' : `${leftWidth}%` }}>
          <div className="sidebar">
            <div 
              className={`sidebar-item ${activePage === 'Dashboard' ? 'active' : ''}`}
              onClick={() => handleSidebarClick('Dashboard')}
            >
              Dashboard
            </div>
            <div 
              className={`sidebar-item ${activePage === 'Agents' ? 'active' : ''}`}
              onClick={() => handleSidebarClick('Agents')}
            >
              Agents
            </div>
            <div 
              className={`sidebar-item ${activePage === 'Data Sources' ? 'active' : ''}`}
              onClick={() => handleSidebarClick('Data Sources')}
            >
              Data Sources
            </div>
            <div 
              className={`sidebar-item ${activePage === 'Model Connectors' ? 'active' : ''}`}
              onClick={() => handleSidebarClick('Model Connectors')}
            >
              Model Connectors
            </div>
          </div>
          <div className="content">
            {activePage === 'Dashboard' && <h2>Dashboard</h2>}
            {activePage === 'Agents' && (
              viewingAgentUsage ? (
                <AgentData 
                  agent={viewingAgentUsage} 
                  onBackToEdit={(agentId) => {
                    setViewingAgentUsage(null);
                    setEditingAgent(agentId);
                  }}
                />
              ) : viewingAgentTables ? (
                <AgentTables 
                  agent={viewingAgentTables} 
                  onBack={() => {
                    setViewingAgentTables(null);
                    setEditingAgent(viewingAgentTables.id);
                  }}
                />
              ) : editingAgent ? (
                <AgentEdit 
                  agent={{ id: editingAgent }} 
                  onCancel={() => setEditingAgent(null)}
                  onUnsavedChange={setHasUnsavedChanges}
                  onViewUsage={(agent) => {
                    setEditingAgent(null);
                    setViewingAgentUsage(agent);
                  }}
                  onViewTables={(agent) => {
                    setEditingAgent(null);
                    setViewingAgentTables(agent);
                  }}
                />
              ) : (
                <Agents onEditAgent={(agentId) => setEditingAgent(agentId)} />
              )
            )}
            {activePage === 'Data Sources' && (
              editingDatasource ? (
                <DatasourceEdit 
                  datasourceId={editingDatasource} 
                  onCancel={() => setEditingDatasource(null)}
                  onUnsavedChange={setHasUnsavedDatasourceChanges}
                />
              ) : (
                <Datasources onEdit={(id) => {
                  setEditingDatasource(id);
                  setHasUnsavedDatasourceChanges(false);
                }} />
              )
            )}
            {activePage === 'Model Connectors' && (
              editingModelconnector ? (
                <ModelconnectorEdit 
                  modelconnectorId={editingModelconnector} 
                  onCancel={() => setEditingModelconnector(null)}
                  onUnsavedChange={setHasUnsavedModelconnectorChanges}
                />
              ) : (
                <Modelconnectors onEdit={(id) => setEditingModelconnector(id)} />
              )
            )}
          </div>
        </div>
        <div 
          className="separator"
          onMouseDown={handleMouseDown}
        >
          <div 
            className="separator-toggle"
            onClick={toggleRightPanel}
            onMouseDown={(e) => e.stopPropagation()}
          >
            {isRightPanelCollapsed ? '\u25c0' : '\u25b6'}
          </div>
        </div>
        <div className="right-panel" style={{ 
          width: isRightPanelCollapsed ? '0%' : `${100 - leftWidth}%`,
          overflow: 'hidden'
        }}>
          <Assistant />
        </div>
      </div>
      {showUnsavedModal && (
        <div className="modal-overlay" style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }}>
          <div className="modal-content" style={{ width: '400px', height: 'auto', padding: '20px', backgroundColor: 'white', borderRadius: '8px' }}>
            <h3>Unsaved Changes</h3>
            <p>You have unsaved changes. Do you want to leave without saving?</p>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '20px' }}>
              <button onClick={cancelNavigation} className="btn-cancel">Stay</button>
              <button onClick={confirmNavigation} className="btn-save">Leave</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Home;